import styled from 'styled-components';
import { ButtonPrimary } from '@spotify-internal/encore-web';
import {
  BREAKPOINT_SMALL,
  MarketingHeading1,
} from 'components/MarketingPagesShared/styles';
import { HomeSection } from '../../../styles';
import { CDN_PATH } from '../../../constants';

export const HomeHeroBackground = styled.div`
  background-image: url(${CDN_PATH}/bg-hero.svg);
  background-repeat: no-repeat;
  background-size: contain;
  background-position-y: 50%;

  @media (max-width: ${BREAKPOINT_SMALL}px) {
    background-image: url(${CDN_PATH}/bg-hero-mobile.svg);
    background-size: 100%;
    background-position-y: 60%;
  }
`;

export const HomeHeroSection = styled(HomeSection)`
  display: grid;
  grid-template-columns: 40% 20% 40%;
  grid-template-rows: auto;
  grid-template-areas:
    'title title title-image'
    'left-image right-image right-image';
  padding-right: 0;
  @media (max-width: ${BREAKPOINT_SMALL}px) {
    grid-template-rows: auto;
    grid-template-areas:
      'title title title'
      'left-image . title-image'
      'right-image . .';
  }
`;

export const HomeHeroTitleContainer = styled.div`
  grid-area: title;
  @media (max-width: ${BREAKPOINT_SMALL}px) {
    padding: 0 26px;
  }
`;

export const HomeHeroSideImage = styled.div`
  grid-area: title-image;
  margin: 40px -15% 0 20%;
  align-self: center;
  justify-content: end;
  @media (max-width: ${BREAKPOINT_SMALL}px) {
    margin: 40% 0 0 0;
  }
`;

export const HomeHeroBottomLeftImage = styled.div`
  grid-area: left-image;
  margin: -15% 0 0 -15%;

  @media (max-width: ${BREAKPOINT_SMALL}px) {
    margin: 15% -40px 0 0%;
  }
`;

export const HomeHeroBottomRightImage = styled.div`
  grid-area: right-image;
  margin: 20% 30% 0 20%;
  @media (max-width: ${BREAKPOINT_SMALL}px) {
    margin: -45% 0% 0 20%;
  }
`;

export const HomeHeroTitle = styled(MarketingHeading1)`
  margin: 150px 0 40px;

  @media (max-width: ${BREAKPOINT_SMALL}px) {
    margin-top: 40px;
  }
`;

export const HomeHeroSubtitle = styled.div`
  margin-bottom: 150px;
  & > h2 {
    font-weight: normal;
    font-size: 2.25rem;
    line-height: 1.25;
  }

  & > a {
    width: 256px;
    margin-top: 24px;
    text-decoration: none;
  }

  @media (max-width: ${BREAKPOINT_SMALL}px) {
    margin-bottom: 50px;
    & > h2 {
      font-size: 2rem;
    }
    & > a {
      width: 100%;
    }
  }
`;

export const HomeHeroSignUpButton = styled(ButtonPrimary)`
  border-color: #e8f524;
  color: black;
  background-color: #e8f524;

  &&:focus,
  &&:hover {
    transform: none;
    border-color: #f4ff50;
    background-color: #f4ff50;
  }
`;
